// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"4520937b","417":"6b2725dc","764":"05227dae"}[chunkId] + ".chunk.js";
};